<div [ngStyle]="minScrollStyle" *ngIf="dataLoaded">
  <router-outlet></router-outlet>
</div>
